import { SvgIcon } from "@mui/material";

export const Trezor = (props: any) => {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#a)">
          <path
            d="M16.74 6.775c0-2.473-2.14-4.525-4.743-4.525S7.254 4.303 7.254 6.775v1.447H5.303v10.403l6.692 3.125 6.697-3.125V8.268h-1.951zm-7.068 0c0-1.166 1.023-2.1 2.325-2.1s2.325.934 2.325 2.1v1.447h-4.65zm6.323 10.17-4 1.868-3.999-1.866v-6.253h8z"
            fill="currentColor"></path>
        </g>
        <defs>
          <clipPath id="a">
            <path fill="currentColor" d="M0 0h24v24H0z"></path>
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};
